import { createAction, props } from '@ngrx/store';
import { Offer, OfferFilters, OfferMetadata } from '@app/core/_models/offer-interface';
import { PaginationInfo } from '@app/shared/types/pagination';

const TAG = '[Offers]';

export const loadMetadata = createAction(`${TAG} Load metadata`);
export const metadataLoaded = createAction(`${TAG} Metadata loaded`, props<{ data: OfferMetadata }>());

export const clearFilteredOffers = createAction(`${TAG} Clear filtered offers`);
export const loadFilteredOffers = createAction(`${TAG} Load filtered offers`, props<{ filters: OfferFilters }>());
export const offersLoaded = createAction(`${TAG} Offers loaded`, props<{
  offers: Offer[];
  paginationInfo: PaginationInfo;
}>());

export const loadOffer = createAction(`${TAG} Load offer`, props<{ id }>());
export const offerLoaded = createAction(`${TAG} Load offer`, props<{ offer: Offer | null }>());
export const useOffer = createAction(`${TAG} Use offer`, props<{ id }>());
export const offerUsed = createAction(`${TAG} Offer used`, props<{ offer: Offer | null }>());
